import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './en.json';
import nbNO from './nb-NO.json';
import nnNO from './nn-NO.json';

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      'nb-NO': { translation: nbNO },
      'nn-NO': { translation: nnNO },
    },
    fallbackLng: 'en',
    supportedLngs: ['en', 'nb-NO', 'nn-NO'],
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'dim-language',
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

export default i18n;
